import React, { useState, useRef } from "react";
import TcNav from "./TcNav";
import img from "../../assests/1.png";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const LicensePlateCapture = () => {
  const imageRef = useRef();
  const inputRef = useRef();

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileUpload = () => {
    const file = inputRef.current.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        imageRef.current.src = e.target.result;
        
      };

      reader.readAsDataURL(file);
      setSelectedFile(file);
    }
  };

  const handleUpload = async () => {
    setLoading(true);
  
    const formData = new FormData();
    formData.append("file", selectedFile);
  
    try {
      const response = await fetch("http://localhost:5000/upload", {
        method: "POST",
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();

      toast.warn("Careful about the accuracy!!!", {
        position: "top-left",
        autoClose: 2000,
        theme: "dark",
      });
  
      if (data.generated_text) {
        
      } else {
        throw new Error("No generated text in response");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div>
      <header>
        <TcNav />
      </header>

      <main className="d-flex  flex-column justify-content-center align-items-center mt-5">
        <h4 className="text-white mt-5">License Plate Number Detection</h4>
        <div className="d-flex  flex-column justify-content-center align-items-center">
          <div className=".bg-light-subtle w-50 mt-5  mb-3 ">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              ref={inputRef}
              placeholder="Upload Image"
              className="btn btn-light w-100 d-flex mb-2"
            />

            <div className="text-center mt-2 mb-5">
              <button
                className="btn btn-outline-light w-100 mb-2"
                onClick={handleUpload}
                disabled={loading} // Disable the button while loading
              >
                {loading ? "Loading, Please Wait" : "See Results"}
              </button>
              
              
                
                <div className="text-white mt-2 mb-3">
                  <p className="text-info">Extracted License Plate Image:</p>
                  <img
                    src={img}
                    className="h-50 w-50 text-white rounded"
                    alt="Extracted License Plate"
                  />
                </div>
                <div className="text-white mt-2 mb-3">
                  <p>Original Image:</p>
                  <img
                    id="image-upload"
                    src=""
                    className="h-25 w-100 text-white rounded"
                    ref={imageRef}
                    alt="Uploaded Preview"
                  />
                
              </div>
            </div>
          </div>
        </div>
      </main><ToastContainer/>
    </div>
  );
};

export default LicensePlateCapture;
